<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'"
          >{{ aLang.c_create }} {{ aLang.ev_title }}</span
        >
        <span v-if="mData.viewMode == 'update'"
          >{{ aLang.c_update }} {{ aLang.ev_title }}</span
        >
        <span v-if="mData.viewMode == 'detail'"
          >{{ aLang.c_detail }} {{ aLang.ev_title }}</span
        >
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-form-item :label="aLang.ev_assessor" prop="nguoi_danh_gia_id">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten_nguoi_danh_gia"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item
                :label="aLang.ev_object_type"
                prop="loai_doi_tuong_danh_gia"
              >
                <el-select
                  v-model="mData.dataForm.loai_doi_tuong_danh_gia"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listLoaiDoiTuongDanhGia"
                    :key="item.code"
                    :label="item.text"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <el-form-item
                :label="aLang.ev_assessment_object"
                prop="doi_tuong_danh_gia_id"
              >
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten_doi_tuong_danh_gia"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item :label="aLang.ev_evaluate" prop="gia_tri">
                <el-input
                  type="text"
                  v-model="mData.dataForm.gia_tri"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item :label="aLang.ev_created_time" prop="thoi_diem_tao">
                <el-date-picker
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataForm.thoi_diem_tao"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12" class="mb-2">{{
              aLang.ev_detailed_ingredient_evaluation
            }}</b-col>
            <b-col md="12">
              <el-table
                :data="mData.dataForm.thanh_phan"
                border
                max-width="500"
                style="width: 100%"
              >
                <el-table-column
                  prop="ten_thanh_phan_danh_gia"
                  :label="aLang.ev_ingredient_evaluation_team"
                ></el-table-column>
                <el-table-column
                  prop="ten_gia_tri_danh_gia"
                  :label="aLang.ev_value"
                  width="300"
                ></el-table-column>
                <!-- <el-table-column
                  :label="aLang.c_action"
                  align="center"
                  width="150px"
                  v-if="mData.viewMode != 'detail'"
                >
                  <template slot-scope="scope">
                    <el-button size="mini" @click="fn_deleteKhachDuLich(scope.$index)">
                      <i class="icon-trash icons"></i>
                    </el-button>
                  </template>
                </el-table-column>-->
              </el-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item :label="aLang.ev_content" prop="noi_dung">
                <el-input
                  type="textarea"
                  :rows="6"
                  v-model="mData.dataForm.noi_dung"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item :label="aLang.ev_violation_criteria">
                <el-checkbox-group v-model="mData.dataDefault.listThongTinThem">
                  <el-checkbox
                    v-for="item in mData.dataDefault.listThongTinThem"
                    :label="item"
                    :key="item"
                    disabled
                    >{{ item }}</el-checkbox
                  >
                </el-checkbox-group>
                <!-- <p v-for="item in mData.dataDefault.listThongTinThem">{{ item }}</p> -->
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
              >{{ aLang.c_create }}</el-button
            >

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
              >{{ aLang.c_update }}</el-button
            >

            <el-button @click="fn_go()" type="info" plain>{{
              aLang.c_back
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- modal Thanh Phan -->
    <!-- <el-dialog
      :close-on-click-modal="false"
      title="Đánh giá thành phần"
      :visible.sync="mData.dialog.ThanhPhan"
      width="60%"
      top="51px"
    >
      <div class="card-body scroll-y-80vh">
        <el-form
          :model="mData.dataFormThanhPhan"
          :rules="mData.validFormThanhPhan"
          ref="myFormThanhPhan"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-form-item label="Nhóm đánh giá thành phần" prop="nhom_id">
                <el-select
                  v-model="mData.dataFormThanhPhan.nhom_id"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listNhomTPDanhGia"
                    :key="item.id"
                    :label="item.ten.vi"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>

            <b-col md="6">
              <el-form-item label="Giá trị" prop="gia_tri">
                <el-input type="number" v-model="mData.dataFormThanhPhan.gia_tri" clearable></el-input>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              v-ladda
              @click="fn_handleThanhPhan('create')"
              v-if="mData.dataDefault.ThanhPhan.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>
            <el-button
              type="info"
              plain
              v-ladda
              @click="fn_handleThanhPhan('update')"
              v-if="mData.dataDefault.ThanhPhan.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>
            <el-button @click="mData.dialog.ThanhPhan = false" type="info" plain>{{aLang.c_close}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>-->
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import DanhGiaModel from "./DanhGiaModel";
import mushroom from "../../../service/api/dulich-api";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "DanhGia",
        dataDefault: {
          roles: DataService.rolesInForm,
          listNguoiDanhGia: [],
          listDoiTuongDanhGia: [],
          listTour: [],
          listHuongDanVien: [],
          listDichVuChatLuongCao: [],
          listNhomTPDanhGia: [],
          listLoaiDoiTuongDanhGia: DanhGiaModel.loaiDoiTuongDanhGia,
          listGiaTriTPDanhGia: DataService.giaTriDanhGiaThanhPhan,
          ThanhPhan: {
            viewMode: "create",
            indexModal: undefined,
          },
          listThongTinThem: [],
        },
        dataForm: MethodService.copyObject(DanhGiaModel.dataForm),
        validForm: DanhGiaModel.validForm,
        dataFormThanhPhan: MethodService.copyObject(
          DanhGiaModel.dataFormOther.thanh_phan
        ),
        validFormGiayTo: DanhGiaModel.validFormOther.thanh_phan,
        dialog: {
          ThanhPhan: false,
        },
      },
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (type == "create") {
            await mushroom.danh_gia.createAsync(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await mushroom.danh_gia.partialUpdateAsync(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await mushroom.danh_gia.findByIdAsync({ id: id });
      if (!res.result) {
        res = await mushroom.danh_gia_log.findByIdAsync({ id: id });
      }

      let resTenNguoiDanhGia = await mushroom.khach_du_lich.findByIdAsync({
        id: res.result.nguoi_danh_gia_id,
      });
      if (resTenNguoiDanhGia.result) {
        if (
          resTenNguoiDanhGia.result &&
          resTenNguoiDanhGia.result.ho_ten.ho_ten &&
          resTenNguoiDanhGia.result.ho_ten.ho_ten.trim() != ""
        ) {
          res.result.ten_nguoi_danh_gia =
            resTenNguoiDanhGia.result.ho_ten.ho_ten;
        } else {
          res.result.ten_nguoi_danh_gia = "Chưa có thông tin";
        }
      } else {
        let resTenNguoiDanhGiaHDV = await mushroom.huong_dan_vien.findByIdAsync(
          {
            id: res.result.nguoi_danh_gia_id,
          }
        );
        if (resTenNguoiDanhGiaHDV.result) {
          res.result.ten_nguoi_danh_gia =
            resTenNguoiDanhGiaHDV.result.ho_ten.ho_ten;
        } else {
          let resTenNguoiDanhGiaDDAT =
            await mushroom.diem_den_an_toan.listAsync({
              limit: 1000,
              filters: "nguoi_tao_id:in:" + res.result.nguoi_danh_gia_id,
            });

          if (
            resTenNguoiDanhGiaDDAT.result &&
            resTenNguoiDanhGiaDDAT.result.length > 0
          ) {
            res.result.ten_nguoi_danh_gia =
              resTenNguoiDanhGiaDDAT.result[0].thong_tin_chung.ten;
          }
        }
      }

      if (res.result.loai_doi_tuong_danh_gia == "tour") {
        let resDoiTuongDanhGia = await mushroom.tour.findByIdAsync({
          id: res.result.doi_tuong_danh_gia_id,
        });
        res.result.ten_doi_tuong_danh_gia = resDoiTuongDanhGia.result.ten_tour;
      } else {
        if (res.result.loai_doi_tuong_danh_gia == "tour_guide") {
          let resDoiTuongDanhGia = await mushroom.huong_dan_vien.findByIdAsync({
            id: res.result.doi_tuong_danh_gia_id,
          });
          res.result.ten_doi_tuong_danh_gia =
            resDoiTuongDanhGia.result.ho_ten.ho_ten;
        } else {
          if (res.result.loai_doi_tuong_danh_gia == "hq_service") {
            let resDoiTuongDanhGia =
              await mushroom.dich_vu_chat_luong_cao.findByIdAsync({
                id: res.result.doi_tuong_danh_gia_id,
              });
            res.result.ten_doi_tuong_danh_gia =
              resDoiTuongDanhGia.result.ten.vi;
          } else {
            if (res.result.loai_doi_tuong_danh_gia == "safe_place") {
              let resDoiTuongDanhGia =
                await mushroom.diem_den_an_toan.findByIdAsync({
                  id: res.result.doi_tuong_danh_gia_id,
                });
              res.result.ten_doi_tuong_danh_gia =
                resDoiTuongDanhGia.result.thong_tin_chung.ten;
            } else {
              if (res.result.loai_doi_tuong_danh_gia == "accommodation") {
                let resDoiTuongDanhGia =
                  await mushroom.co_so_luu_tru.findByIdAsync({
                    id: res.result.doi_tuong_danh_gia_id,
                  });
                res.result.ten_doi_tuong_danh_gia =
                  resDoiTuongDanhGia.result.ten.vi;
              } else {
                if (res.result.loai_doi_tuong_danh_gia == "tourist") {
                  let resDoiTuongDanhGia =
                    await mushroom.khach_du_lich.findByIdAsync({
                      id: res.result.doi_tuong_danh_gia_id,
                    });
                  if (
                    resDoiTuongDanhGia.result.ho_ten &&
                    resDoiTuongDanhGia.result.ho_ten.ho_ten &&
                    resDoiTuongDanhGia.result.ho_ten.ho_ten.trim() != ""
                  ) {
                    res.result.ten_doi_tuong_danh_gia =
                      resDoiTuongDanhGia.result.ho_ten.ho_ten;
                  } else {
                    res.result.ten_doi_tuong_danh_gia = "Chưa có thông tin";
                  }
                } else {
                  res.result.ten_doi_tuong_danh_gia = "";
                }
              }
            }

            // res.result.ten_doi_tuong_danh_gia = "";
          }
        }
      }
      this.changeData(res.result.thanh_phan);

      if (
        res.result.thong_tin_them &&
        res.result.thong_tin_them.kpis &&
        res.result.thong_tin_them.kpis.length > 0
      ) {
        this.mData.dataDefault.listThongTinThem =
          res.result.thong_tin_them.kpis;
      }

      this.mData.dataForm = res.result;
    },

    //xử lý dữ liệu đầu ra
    changeData(data) {
      $.each(data, (index, item) => {
        let thanhPhanDanhGia = this.mData.dataDefault.listNhomTPDanhGia.find(
          (element) => {
            return element.id == item.nhom_id;
          }
        );
        if (thanhPhanDanhGia) {
          item.ten_thanh_phan_danh_gia = thanhPhanDanhGia.ten.vi;
        }
        let giaTriDanhGia = this.mData.dataDefault.listGiaTriTPDanhGia.find(
          (element) => {
            return element.code == item.gia_tri;
          }
        );
        if (giaTriDanhGia) {
          item.ten_gia_tri_danh_gia = giaTriDanhGia.text;
        }
      });
      return data;
    },

    async fn_initDataDefault() {
      let resNhomTPDanhGia =
        await mushroom.nhom_thanh_phan_danh_gia.listAsync();
      this.mData.dataDefault.listNhomTPDanhGia = resNhomTPDanhGia.result;
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },
  },
  created: function () {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function () {},
};
</script>
